const UrlPrefix_dev = {
	Auth: '/Idea.Auth/api',
	Token: '/Idea.Web/Home',
	Link: '/Idea.Web/Home',
	Server: '/Idea.Server/api',
	AdminServer: '/Idea.Admin.Server/api/',
	Upload: '/Idea.Server/uploads',
	Root: '/Idea.Web/'
};
const UrlPrefix_live = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/server/api',
	AdminServer: '/adminserver/api/',
	Upload: '/server/uploads'
};

const UrlPrefix_livesk = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/serversk/api',
	AdminServer: '/adminserver/api/',
	Upload: '/serversk/uploads'
};
const UrlPrefix_livehu = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/serverhu/api',
	AdminServer: '/adminserver/api/',
	Upload: '/serverhu/uploads'
};

const UrlPrefix_liveua = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/serverua/api',
	AdminServer: '/adminserver/api/',
	Upload: '/serverua/uploads'
};

const UrlPrefix_livepl = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/serverpl/api',
	AdminServer: '/adminserver/api/',
	Upload: '/serverpl/uploads'
};

const UrlPrefix_liveru = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/voserver/api',
	AdminServer: '/adminserver/api/',
	Upload: '/voserver/uploads'
};

const UrlPrefix_liveest = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/serverest/api',
	AdminServer: '/adminserver/api/',
	Upload: '/serverest/uploads'
};

const UrlPrefix_liveeng = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/voenserver/api',
	AdminServer: '/adminserver/api/',
	Upload: '/voenserver/uploads'
};

const UrlPrefix_liveger = {
	Auth: '/auth/api',
	Token: '/Home',
	Link: '/Home',
	Root: '/',
	Server: '/vogeserver/api',
	AdminServer: '/adminserver/api/',
	Upload: '/vogeserver/uploads'
};

function UrlPrefix() {
	switch (Config.mode) {
		case "debug":
			return UrlPrefix_dev;
		case "livelocal":
			return UrlPrefix_dev;
		case "live":
			return UrlPrefix_live;
		case "livesk":
			return UrlPrefix_livesk;
		case "livehu":
			return UrlPrefix_livehu;
		case "liveua":
			return UrlPrefix_liveua;
		case "liveru":
			return UrlPrefix_liveru;
		case "liveger":
			return UrlPrefix_liveger;
		case "liveest":
			return UrlPrefix_liveest;
		case "liveeng":
			return UrlPrefix_liveeng;
		case "livepl":
			return UrlPrefix_livepl;
		default:
			return UrlPrefix_dev;
	}
}

export const Routes = {
	Home: UrlPrefix().Root,
	Register: UrlPrefix().Root + 'account/register',
	SucessRegistration: UrlPrefix().Root + 'account/successregistration',
	SignIn: UrlPrefix().Root + 'account/signIn',
	SignOut: UrlPrefix().Root + 'account/signOut',
	Login: UrlPrefix().Root + 'account/login',
	SuccessLogin: UrlPrefix().Root + 'account/successlogin',
	ConfirmPassword: UrlPrefix().Root + 'account/resetPassword',
	LostPassword: UrlPrefix().Root + 'account/lostPassword',
	ChangePassword: UrlPrefix().Root + 'account/manage',
	EditUser: UrlPrefix().Root + 'account/edit',
	Order: UrlPrefix().Root + 'account/order',
	OrderView: UrlPrefix().Root + 'account/orderview',
	Orders: UrlPrefix().Root + 'account/orders',

	Cart: UrlPrefix().Root + 'home/cart',
	Search: UrlPrefix().Root + 'home/search',
	TradeTerms: UrlPrefix().Root + 'home/page/tradeterms',
	Gdpr: UrlPrefix().Root + 'home/page/Protection',
	Checkout: UrlPrefix().Root + 'checkout/deliveries',
	CheckoutUser: UrlPrefix().Root + 'checkout/customer',
	CheckoutRepeatPayment: UrlPrefix().Root + 'checkout/repeatpayment',
	CheckoutFinish: UrlPrefix().Root + 'checkout/finish'
};

export const Constants = {
	Url: {
		Manage: UrlPrefix().Auth + '/account/manage',
		ResetPassword: UrlPrefix().Auth + '/account/resetpassword',
		Suggestions: UrlPrefix().Server + '/search/suggestions',
		ProductIds: UrlPrefix().Server + '/product/list',
		MailkitSignUp: UrlPrefix().Server + '/user/mailkitsignup',
		LeafletSignUp: UrlPrefix().Server + '/user/leafletsignup',
		CalculateCart: UrlPrefix().Server + '/cart/calculate',
		CalculateOrder: UrlPrefix().Server + '/order/calculate',
		PlaceOrder: UrlPrefix().Server + '/order/place',
		RepeatPayment: UrlPrefix().Server + '/order/repeatpayment',
		ClearCart: UrlPrefix().Server + '/cart/clear',
		CartAdditionalInfo: UrlPrefix().Server + '/cart/additionalinfo',
		DeliveryOptions: UrlPrefix().Server + '/order/deliveryoptions',
		DeliveryPlaces: UrlPrefix().Server + '/order/deliveryPlaces',
		GetUser: UrlPrefix().Server + '/user/get',
		GetUserWithStats: UrlPrefix().Server + '/user/getWithStats',
		SignIn: UrlPrefix().Root + 'account/signIn',
		UpdateUser: UrlPrefix().Server + '/user/update',
		OrderList: UrlPrefix().Server + '/order/list',
		GetOrder: UrlPrefix().Server + '/order/get',
		GetOrderByInvoiceCode: UrlPrefix().Server + '/order/getbyinvoicecode',
		CancelOrder: UrlPrefix().AdminServer + 'order/cancel',
		SendResetPassword: UrlPrefix().Server + '/user/sendresetpasswordlink',
		Barems: UrlPrefix().Server + '/cetelem/barems',
		Insuarences: UrlPrefix().Server + '/cetelem/insuarences',
		CalculateCetelem: UrlPrefix().Server + '/cetelem/calculate'
	}
};
